module.exports = __webpack_public_path__ + "routes/urzad/szczegolyUrzedu/powrot_do_mapy.png?b11b0239";


//////////////////
// WEBPACK FOOTER
// ./routes/urzad/szczegolyUrzedu/powrot_do_mapy.png
// module id = 1755
// module chunks = 0